import React, { useEffect } from "react";

import PopUp from "Components/PopUp/PopUp";
import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
function InfoDialog({
  openInfo,
  setOpenInfo,
  info,
  setInfo,
  handlePayment,
  loading,
}) {
  useEffect(() => {
    if (openInfo) {
      setInfo({});
    }
  }, [openInfo]);
  return (
    <PopUp
      open={openInfo}
      setOpen={setOpenInfo}
      title="Please Enter Your Information"
    >
      <form
        className="flex items-center  flex-col w-full gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          handlePayment();
        }}
      >
        <div className="flex items-center  w-full gap-6 justify-between">
          <TextInput
            label="First Name"
            required={true}
            placeholder="John"
            type="text"
            className={"border-border-darkNew"}
            value={info.firstName}
            onChange={(e) => setInfo({ ...info, firstName: e.target.value })}
          />
          <TextInput
            label="Last Name"
            required={true}
            placeholder="Doe"
            type="text"
            className={"border-border-darkNew"}
            value={info.lastName}
            onChange={(e) => setInfo({ ...info, lastName: e.target.value })}
          />
        </div>
        <TextInput
          label="Email"
          required={true}
          placeholder="example@gmail.com"
          type="email"
          className={"border-border-darkNew"}
          value={info.email}
          onChange={(e) => setInfo({ ...info, email: e.target.value })}
        />
        <Button
          disabled={loading || !(info.firstName && info.lastName && info.email)}
          className="w-full"
        >
          {loading ? "Processing..." : "Continue"}
        </Button>
      </form>
    </PopUp>
  );
}

export default InfoDialog;
